/* tslint:disable:max-line-length */
import React from 'react';
import classNames from 'classnames';
import { IconTypeProps } from '../types';

export const UnreadMessageIcon = ({
  className,
  style,
  color = '#3952FA',
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      style={style}
      width="11"
      height="9"
      viewBox="0 0 11 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4387 0.497966C10.7158 0.740421 10.7438 1.1616 10.5014 1.43869L4.87639 7.86726C4.75675 8.00399 4.58648 8.08597 4.40498 8.09423C4.22348 8.10249 4.04647 8.03632 3.91491 7.91101L0.539906 4.69673C0.273285 4.4428 0.262993 4.02082 0.516917 3.7542C0.770841 3.48758 1.19283 3.47729 1.45945 3.73121L4.33088 6.46591L9.49796 0.560681C9.74041 0.283589 10.1616 0.255511 10.4387 0.497966Z"
        fill={color}
      />
    </svg>
  );
};
